import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { AlertsService } from "./alerts.service";
import { AlertTranslation } from "../shared/translation.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

@Component({
  selector: "edit-alert",
  template: require('./createalert.component.html'),
  styles: [require('./createalert.component.scss')]
})
export class EditAlertComponent implements OnInit {
  alert: any;
  translations: any[] = [];
  languages: any[] = this.getLanguages();
  alertTypes: any[] = this.service.getAlertTypes();
  sent: boolean = false;
  responseValues: any[] = [];
  activePanels: string[] = ["visibility"];
  editMode: boolean = true;
  @ViewChild("modalTemplate") private modalComponent: TemplateRef<any>;
  dialog: NgbModalRef;

  constructor(
    private service: AlertsService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    this.alert = AlertsService.currentAlert;
    if (this.alert) {
      this.translations = this.getTranslations();
    } else {
      this.router.navigate(["/alerts"]);
    }
  }

  getLanguages(): any[] {
    return this.service.getLanguages();
  }

  getTranslations() {
    let translations = [];
    Object.keys(this.alert.content).map((key, index) => {
      let it = this.alert.content[key];
      let t = new AlertTranslation();
      t.language = key;
      t.description = it.description;
      t.title = it.title;
      t.author = it.author;
      translations.push(t);
      this.activePanels.push("translations" + (translations.length - 1));
    });
    return translations;
  }

  addTranslation() {
    this.translations.push(new AlertTranslation());
    this.activePanels.push("translations" + (this.translations.length - 1));
  }

  deleteTranslation(item: any) {
    let index = this.translations.indexOf(item);
    if (index > -1) {
      this.translations.splice(index, 1);
      this.activePanels.splice(this.activePanels.length - 1, 1);
    }
  }

  getPanelTitle(translation: AlertTranslation, first: boolean) {
    let text;
    let selectedLang = this.languages.filter((language: any) => {
      return language.key === translation.language;
    })[0];
    text =
      selectedLang && selectedLang.value
        ? selectedLang.value
        : "Choose a language";
    if (first) {
      text += " (Default)";
    }
    return text;
  }

  setDefault(index: number) {
    let t = this.translations[0];
    this.translations[0] = this.translations[index];
    this.translations[index] = t;
  }

  showModal() {
    if (!this.sent) {
      this.dialog = this.modalService.open(this.modalComponent);
    }
  }

  deleteAlert(result) {
    this.dialog.close();
    if (result) {
      this.sent = true;
      this.service.deleteAlert(this.alert.id).subscribe(
        (res) => {
          this.back();
        },
        (error) => {
          this.sent = false;
        }
      );
    }
  }

  back() {
    window.history.back();
  }

  onSubmit() {
    this.activePanels = [];
    setTimeout(() => {
      this.save();
    }, 1);
  }

  save() {
    if (!this.sent) {
      this.sent = true;
      let defLang;
      this.translations.map((it: any) => {
        if (it.language !== "") {
          if (!defLang) {
            defLang = it.language;
          }
          this.alert.content[it.language] = {
            author: it.author,
            title: it.title,
            description: it.description
          };
        }
      });
      this.alert.default_lang = defLang;
      let alertCopy = Object.assign({}, this.alert);
      delete alertCopy.context.employerNames;
      delete alertCopy.context.projectNames;
      this.service.editAlert(alertCopy).subscribe(
        (response) => {
          this.sent = false;
          this.back();
        },
        (error) => {
          this.activePanels = ["visibility"];
          this.translations.map((it, index) => {
            this.activePanels.push("translations" + index);
          });
          this.sent = false;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/alerts/editalert.component.ts